import React, { createContext } from 'react';
import { useModelItemList } from './context.item.list';
import { useModelItemsItemForm } from './context.items.item.form';
import { useModelItemListPopup } from './context.item.list.popup';

export const ContextItems = createContext<any>(null);

const ContextProviderItems: React.FC<{ children: any }> = ({ children }) => {
  const context = {
    useModelItemList,
    useModelItemsItemForm,
    useModelItemListPopup,
  };

  return <ContextItems.Provider value={context}>{children}</ContextItems.Provider>;
};

export default ContextProviderItems;
